<!--
    רקע המערכת - the settings-page section (הגדרות → כללי) for the very faint drawing on the gray behind the cards
    (Common/page-backdrops.js, painted by PageBackdrop in App.vue). Off ("ללא") by default.

    A tile is a small page - header, menu, a card - with its design behind, drawn a little stronger than the real
    thing so the shape reads at that size. A click saves at once, for the whole account
    (homepage_setting.settings.pageBackground) - nothing goes through the tab's שמור - and the page behind the
    settings changes right away.
-->
<template>
    <div class="pageBackgroundSettings">

        <div class="pageBackgroundSettingsIntro">
            ציור עדין מאוד על הרקע האפור שמאחורי הכרטיסים, בכל דפי המערכת.
            הבחירה נשמרת מיד, לכל המשתמשים בחשבון.
        </div>

        <div class="pageBackgroundTiles"
             role="radiogroup"
             aria-label="רקע המערכת">

            <button v-for="option in options"
                    :key="option.key || 'none'"
                    type="button"
                    role="radio"
                    class="pageBackgroundTile"
                    :class="{ selected: option.key == current }"
                    :aria-checked="option.key == current ? 'true' : 'false'"
                    :data-backdrop-option="option.key || 'none'"
                    @click="pick(option.key)">

                <span class="pageBackgroundTilePreview">
                    <PageBackdrop :backdrop="option.key"
                                  preview
                                  :strength="1.8"></PageBackdrop>
                    <span class="pageBackgroundTileHeader"></span>
                    <span class="pageBackgroundTileMenu"></span>
                    <span class="pageBackgroundTileCard"></span>
                    <i v-if="option.key == current"
                       class="fa-solid fa-circle-check pageBackgroundTileCheck"></i>
                </span>

                <span class="pageBackgroundTileLabel">{{ option.label }}</span>

            </button>

        </div>

    </div>
</template>

<script>

import PageBackdrop from '@/components/Common/PageBackdrop.vue';
import { PAGE_BACKDROPS, backdropByKey } from '@/components/Common/page-backdrops';
import { apiPost } from '@/core/http/axios_api_v2';

export default {

    name: 'PageBackgroundSettings',

    components: { PageBackdrop },

    data() {
        return {
            options: [{ key: '', label: 'ללא' }].concat(PAGE_BACKDROPS.map(design => ({ key: design.key, label: design.label }))),
        }
    },

    computed: {

        // '' = the plain gray (also for a key no design has any more)
        current() {
            const key = (this.$store.state.homepageSettings || {}).pageBackground;
            return backdropByKey(key) ? key : '';
        },

    },

    methods: {

        pick(key) {

            if (key == this.current)
                return;

            const state = this.$store.state;
            const before = (state.homepageSettings || {}).pageBackground;

            // the page changes at once; the server merges the key into the blob and hands it back
            state.homepageSettings = Object.assign({}, state.homepageSettings, { pageBackground: key });

            apiPost('homepage-settings', { pageBackground: key }).then(res => {
                if (res && res.settings && state.homepageSettings.pageBackground == key)
                    state.homepageSettings = res.settings;
            }).catch(() => {
                if (state.homepageSettings.pageBackground == key)
                    state.homepageSettings = Object.assign({}, state.homepageSettings, { pageBackground: before });
            });

        },

    },

}

</script>

<style>
.pageBackgroundSettings .pageBackgroundSettingsIntro {
    max-width: 640px;
    color: #777;
    margin-bottom: 14px;
}

.pageBackgroundSettings .pageBackgroundTiles {
    display: flex;
    flex-wrap: wrap;
    gap: 14px;
    margin-bottom: 10px;
}

.pageBackgroundSettings .pageBackgroundTile {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 7px;
    width: 150px;
    padding: 0;
    border: 0;
    background: none;
    color: #555;
    font: inherit;
    cursor: pointer;
}

.pageBackgroundSettings .pageBackgroundTilePreview {
    position: relative;
    display: block;
    width: 100%;
    height: 94px;
    overflow: hidden;
    border-radius: 12px;
    border: 1px solid #e6e8ef;
    box-shadow: 0 1px 2px rgba(42, 49, 66, .04);
    transition: border-color .15s, box-shadow .15s;
}

.pageBackgroundSettings .pageBackgroundTile:hover .pageBackgroundTilePreview {
    border-color: #cdbdf0;
}

.pageBackgroundSettings .pageBackgroundTile.selected .pageBackgroundTilePreview {
    border-color: #ab8ce4;
    box-shadow: 0 0 0 2px rgba(171, 140, 228, .35);
}

.pageBackgroundSettings .pageBackgroundTile:focus-visible {
    outline: none;
}

.pageBackgroundSettings .pageBackgroundTile:focus-visible .pageBackgroundTilePreview {
    box-shadow: 0 0 0 3px rgba(171, 140, 228, .45);
}

/* the small page: the header, the menu on the right, a card */
.pageBackgroundSettings .pageBackgroundTileHeader,
.pageBackgroundSettings .pageBackgroundTileMenu,
.pageBackgroundSettings .pageBackgroundTileCard {
    position: absolute;
    z-index: 1;
    background: #fff;
}

.pageBackgroundSettings .pageBackgroundTileHeader {
    top: 0;
    left: 0;
    right: 0;
    height: 13%;
    border-bottom: 1px solid #eef0f5;
}

.pageBackgroundSettings .pageBackgroundTileMenu {
    top: 13%;
    right: 0;
    bottom: 0;
    width: 15%;
    border-left: 1px solid #eef0f5;
}

.pageBackgroundSettings .pageBackgroundTileCard {
    top: 36%;
    right: 21%;
    left: 6%;
    height: 24%;
    border-radius: 4px;
    box-shadow: 0 1px 3px rgba(42, 49, 66, .07);
}

.pageBackgroundSettings .pageBackgroundTileCheck {
    position: absolute;
    z-index: 2;
    top: 18%;
    left: 6%;
    color: #ab8ce4;
    font-size: 15px;
    background: #fff;
    border-radius: 50%;
}

.pageBackgroundSettings .pageBackgroundTileLabel {
    font-size: 14px;
}

.pageBackgroundSettings .pageBackgroundTile.selected .pageBackgroundTileLabel {
    color: #ab8ce4;
    font-weight: 600;
}

@media (max-width: 575px) {
    .pageBackgroundSettings .pageBackgroundTile {
        width: calc(50% - 7px);
    }
}
</style>
